/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import { Box, CircularProgress } from '@mui/material';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import DataList from './dataList/dataList';
import { Downgraded, useState } from '@hookstate/core';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import StyledTableRow from '../../sharedcomponents/styledTable/styledTableRow';
import StyledTableCell from '../../sharedcomponents/styledTable/styledTableCell';
import Helper from '../../utility/helper';
import AddActivities from './addActivities'
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import { useAuthState } from '../../stores/authStore';
import { useEventState } from '../../stores/eventStore';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        marginTop: '180px'
    },
}));
const AddActivityList = () =>
{
    const classes = useStyles();
    const allData = useState([]);
    const userID = useState(null);
    const eventData = useState(null);
    const loading = useState(true);
    const openDialog = useState(false);
    const setAll = useState(false);
    const authState = useAuthState();
    const eventState = useEventState();
    const editActivityInfo = useState(null);
    const allListData = useState();
    const [modPermission, setModPermission] = React.useState(null);
    const [showSearchRec, setShowSearchRec] = React.useState(false);
    const [filterChangeVal, setFilterChangeVal] = React.useState(false);
    const [filters, setFilters] = React.useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const filteredEmty = useState(false);
    const filteredList = useState([]);
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');

    const onAddRequest = () =>
    {
        editActivityInfo.set(null)
        openDialog.set(true)

    }
    const handleCloseAddActivity = () =>
    {
        editActivityInfo.set(null)
        openDialog.set(false)

    }
    useEffect(() =>
    {
        if (
            userID.get() == null &&
            (eventData.get() == null ||
                (eventData.get() &&
                    eventData.eventID.value != eventInfo.eventID))
        )
        {
            eventData.set(eventInfo);
            userID.set(userInfo.userID);
        }

        const authStateInfo = authState
            .nested('appDetails')
            .attach(Downgraded)
            .get();
        if (
            authState &&
            authStateInfo &&
            authStateInfo.itemsPerPage &&
            pagingInfo.get().itemsPerPage == null
        )
        {
            pagingInfo.set({
                ...pagingInfo,
                currentPage: 1,
                itemsPerPage: authStateInfo.itemsPerPage,
                noOfPages: null,
            });
        }
    }, [authState]);
    useEffect(() =>
    {
        if (eventState && eventState.eventDetail.get())
        {
            if (Helper.isAdminUser(userInfo)|| Helper.isEventStaff(userInfo))
            {
                setModPermission(FULL_PERMISSION);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo))
            {                
                setModPermission(FULL_PERMISSION);
                 
            }
        }

    }, [eventState]);
    useEffect(() =>
    {
        // const pageInfo = pagingInfo.attach(Downgraded).get();
        // if (pageInfo.itemsPerPage)
        // {
        // }
        getActivityList();

    }, []);
    const getActivityList = () =>
    {
        let titlelist = [];
        loading.set(true);
        ApiHelper.get(APIURLConstants.GET_SOCIAL_RESPONSIBILITY_ADD_ACTIVITY_LIST(eventInfo.eventID)).then(res =>
        {
            let data = res.data;
            let requestData = [];
            if (data.length > 0)
            {
                data.map(item =>
                {
                    if (
                        titlelist.indexOf(item.title) ==
                        -1
                    )
                    {
                        titlelist.push(item.title);
                    }
                    requestData.push({
                        actualData: item,
                        row: [
                            {
                                label: 'checkbox',
                                key: 'transportID',
                                transportID: item.masterID,
                                width: '0.05',
                            },
                            {
                                label: 'Title',
                                key: 'participant',
                                participant: item.title,
                                width: '0.50',
                                inColumn: true,
                            },
                            // {
                            //     label: 'Description',
                            //     key: 'description',
                            //     description: item.description,
                            //     width: '0.5',
                            //     inColumn: true,
                            // },
                            {
                                label: 'Tags',
                                key: 'userTags',
                                userTags: item.tagIDs,
                                width: '0.4',
                                showLabel: false,
                                showChips: true,
                                wrapUp: true,
                            },
                            // {
                            //     label: 'Activity Date',
                            //     key: 'headerDate',
                            //     headerDate: Helper.FormatDate(item.dateTime),
                            //     width: '0.10',
                            //     inColumn: true,
                            // },
                            // {
                            //     label: 'StartTime',
                            //     key: 'startTime',
                            //     startTime: item.startTime.slice(0, 5),
                            //     width: '0.10',
                            //     inColumn: true,
                            // },
                            // {
                            //     label: 'EndTime',
                            //     key: 'endTime',
                            //     endTime: item.endTime.slice(0, 5),
                            //     width: '0.10',
                            //     inColumn: true,
                            // },
                            // {
                            //     label: 'Duration',
                            //     key: 'duration',
                            //     duration: item.duration != undefined && item.duration != null ? item.duration : null,
                            //     width: '0.10',
                            //     inColumn: true,
                            // },
                            // {
                            //     label: 'Slot',
                            //     key: 'slot',
                            //     slot: item.slot != undefined && item.slot != null ? item.slot : null,
                            //     width: '0.05',
                            //     inColumn: true,
                            // },
                            {
                                label: 'Action',
                                key: 'All',
                                all: 'All',
                                width: '0.05',
                                inColumn: true,
                            },
                        ]
                    })
                })
                setShowSearchRec(false);
                let filterData = filteredList.attach(Downgraded).get();
                if (filterData.length > 0)
                {
                    setFilterChangeVal(true);
                }
                allData.set(requestData);
                allListData.set(requestData);
                setFilters({
                    title: titlelist,
                    // requestStatus: statusList.attach(Downgraded).get(),
                });
                loading.set(false);

            } else
            {

                allData.set([]);
                allListData.set([]);
                loading.set(false);

            }

        }).catch(err =>
        {
            loading.set(false);
            console.log(err);
        })
    }
    const redirectToEditRequest = (data) =>
    {
        editActivityInfo.set(data.actualData)
        openDialog.set(true)
    };
    const onDelete = () =>
    {
        const selected = allData.get().filter((user) => user.selected === true);
        if (selected.length === 0)
        {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Activity first',
            });
        } else
        {
            let message = setAll.get()
                ? 'Do you want to delete all Activity?'
                : 'Do you want to delete selected Activity?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    }
    const handleConfirmation = () =>
    {
        const gUserInfo = Helper.getStorage('userInfo');
        let deleteRequests = [];
        allData.get().map((row) =>
        {
            if (row.selected === true)
            {
                deleteRequests.push(row.actualData.masterID);
            }

        });
        ApiHelper.post(APIURLConstants.Del_SOCIAL_RESPONSIBILITY_ADD_ACTIVITY, {
            IDs: deleteRequests.join(','),
            modifiedBy: gUserInfo.userID,
        })
            .then((res) =>
            {
                if (res.data)
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    setAll.set(false);
                } else
                {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong',
                    });

                    setAll.set(false);
                }
                getActivityList()

                deleteConfirmation.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
            })
            .catch((error) =>
            {
                let message = '';
                if (error.response && error.response.status === 401)
                {
                    message = 'Access denied';
                } else
                {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
                deleteConfirmation.set({
                    open: false,
                    title: '',
                    OkButtonText: 'Ok',
                    message: '',
                });
            });

    };


    const pagingInfo = useState({
        currentPage: 1,
        itemsPerPage: null,
        noOfPages: null,
    });
    const handlePageChange = (event, page) =>
    {
        pagingInfo.set({
            ...pagingInfo,
            currentPage: page,
            itemsPerPage: pagingInfo.get().itemsPerPage,
            noOfPages: pagingInfo.get().noOfPages,
        });
        getActivityList();
    };
    const handleCloseModule = () =>
    {
        openDialog.set(false);
        editActivityInfo.set(null)
    };
    const filterListData = (data) =>
    {
        if (data.length == 0)
        {
            filteredEmty.set(true);
        } else
        {
            filteredEmty.set(false);
        }
        filteredList.set(data);
    };
    return (
        <Box sx={{ width: '100%' }}>
            {
                loading.get() ? (
                    <Box className={classes.loader}>
                        <CircularProgress />
                    </Box>
                ) :
                    modPermission && modPermission == NO_ACCESS_PERMISSION ? (
                        <UnauthorizedUI showLogout={false} />
                    ) : (
                        <DataList
                            data={allData.attach(Downgraded).get()}
                            title={''}
                            buttonTitle={'Add'}
                            deleteRows={onDelete}
                            showSearch={true}
                            filters={filters}
                            loading={loading.get()}
                            filterChangeVal={filterChangeVal}
                            searchLabel={'Search'}
                            showSearchRec={showSearchRec}
                            setShowSearchRec={setShowSearchRec}
                            getResults={getActivityList}
                            pagingInfo={pagingInfo.attach(Downgraded).get()}
                            handlePageChange={handlePageChange}
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            filterListData={filterListData}
                            handleClick={onAddRequest}
                            editRow={redirectToEditRequest}
                            modPermission={modPermission}

                        />
                    )
            }
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {openDialog.get() && (
                <AddActivities
                    activityInfo={editActivityInfo
                        .attach(Downgraded)
                        .get()}
                    open={openDialog.get()}
                    handleClose={handleCloseAddActivity}
                    handleCloseModule={handleCloseModule}
                    snackBarProps={snackBarProps}
                    setSnackBarProps={setSnackBarProps}
                    getResults={getActivityList}
                />
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() =>
                    {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }
        </Box>

    )
}
export default AddActivityList